import { ArrowUturnLeftIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import {
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { IconSize } from '@constants';
import { RootStyled } from './checkbox-settings.styled';
import { useTranslation } from 'react-i18next';

interface CheckboxSettingProps {
  label: string;
  rank: number;
  defaultValue?: string;
  newValue?: string;
  items: IOption[];
  reset: boolean;
  onChange: (value: string) => void;
  hidden?: boolean;
}
interface IOption {
  label: string;
  value: string;
}
const CheckboxSetting = ({
  items,
  onChange,
  label,
  rank,
  defaultValue,
  newValue,
  reset,
  hidden = false,
}: CheckboxSettingProps) => {
  const theme = useTheme();
  const [value, setValue] = useState<string>();
  const { t } = useTranslation();

  useEffect(() => {
    if (!newValue) return;
    setValue(newValue);
  }, [newValue]);

  useEffect(() => {
    if (!reset) return;
    setValue(defaultValue);
  }, [reset]);
  return (
    <RootStyled attrs={{ hidden }}>
      <Typography variant="h4">
        {rank}. {label}
      </Typography>
      <RadioGroup
        data-qa="reason-radio-group"
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      >
        <Stack direction="row">
          {items.map((item) => (
            <FormControlLabel
              data-qa={`reason-option-${item.label}`}
              key={item.label}
              value={item.value}
              checked={value === item.value}
              control={
                <Radio
                  color="secondary"
                  checkedIcon={
                    <CheckCircleIcon
                      height={IconSize.md}
                      color={theme.palette.primary.main}
                    />
                  }
                />
              }
              label={item.label}
            />
          ))}

          {defaultValue !== undefined && newValue !== undefined && (
            <Tooltip title={t('RESET_TO_DEFAULT')}>
              <IconButton
                onClick={() => {
                  if (defaultValue === undefined) return;
                  setValue(defaultValue);
                  onChange(defaultValue);
                }}
              >
                <ArrowUturnLeftIcon
                  color={theme.palette.dark.dark_1}
                  height={IconSize.buttonIcon}
                />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </RadioGroup>
    </RootStyled>
  );
};
export default CheckboxSetting;
